<template>
  <div class="dashboard-pages">
    <v-card class="pa-3">
      <v-layout row wrap justify-space-between>
        <dt-search-box
          :search="search"
          @typing="searchValue"
          @reset-datatable="resetDataTable()"
          @clear-search-field="search = null"
        />
        <v-layout row wrap justify-end class="pt-2 pb-2">
          <v-btn dark color="primary" v-if="hasPermissions(['sales_store'])" @click="dialogs.addDialog = true">
            <v-icon>add</v-icon>
            {{ $t('datatable-add-new') }}
          </v-btn>
        </v-layout>
      </v-layout>
    </v-card>

    <v-card flat>
      <v-layout row wrap justify-end>
        <v-tooltip :left="!$vuetify.rtl" :right="$vuetify.rtl">
          <template v-slot:activator="{ on }">
            <v-btn
              style="margin: 5px 0px; height: 30px; width: 30px"
              :loading="loadThePrintBtn"
              flat
              fab
              v-on="on"
              color="primary"
              @click="getNoPaginatedData('print')"
            >
              <v-icon>print</v-icon>
            </v-btn>
          </template>
          <span>{{ $t(`Print Table`) }}</span>
        </v-tooltip>
        <v-tooltip :left="!$vuetify.rtl" :right="$vuetify.rtl">
          <template v-slot:activator="{ on }">
            <v-btn
              style="margin: 5px 20px 5px 10px; height: 30px; width: 30px"
              fab
              :loading="loadTheExportBtn"
              flat
              v-on="on"
              color="primary"
              @click="getNoPaginatedData('export')"
            >
              <v-icon>fa-file-excel</v-icon>
            </v-btn>
          </template>
          <span>{{ $t(`Export Table`) }}</span>
        </v-tooltip>
      </v-layout>
    </v-card>

    <v-card class="px-4 pb-4">
      <v-data-table
        v-show="isDatatable"
        :headers="headers"
        :items="resultData.data"
        :item-key="defaultSortBy"
        :search="search"
        :loading="loading"
        :pagination.sync="pagination"
        :rows-per-page-items="pagination.rowsPerPageItems"
        :total-items="resultData.total"
        :no-data-text="$t('No available data')"
        hide-actions
      >
        <template slot="items" slot-scope="props">
          <!--          <td>{{ props.item.sale_id }}</td>-->
          <td>{{ props.item.bill_auto_number }}</td>
          <td>{{ props.item.sale_man_name }}</td>
          <td>{{ props.item.customer_name }}</td>
          <td>{{ props.item.net_amount | currency }}</td>
          <td>{{ props.item.bill_date }}</td>
          <td>{{ $t(props.item.receive_type) }}</td>
          <td>
            <v-tooltip top>
              <v-chip
                slot="activator"
                label
                :color="props.item.bill_status === 'Open' ? 'error' : 'success'"
                text-color="white"
                class="no-select"
              >
                <v-icon>{{ props.item.bill_status === 'Open' ? 'fa-lock-open' : 'fa-lock' }}</v-icon>
              </v-chip>
              <span>{{ props.item.bill_status === 'Open' ? $t('Open') : $t('Close') }}</span>
            </v-tooltip>
          </td>
          <td>
            <v-tooltip top>
              <v-chip
                slot="activator"
                label
                :color="
                  props.item.sale_receive_status === 'Received'
                    ? 'success'
                    : props.item.receive_status === 'Received Partially'
                    ? 'warning'
                    : props.item.receive_status === 'Received'
                    ? 'success'
                    : 'error'
                "
                text-color="white"
                class="no-select"
              >
                <v-icon>
                  {{
                    props.item.sale_receive_status === 'Received'
                      ? 'attach_money'
                      : props.item.receive_status === 'Received Partially'
                      ? 'attach_money'
                      : props.item.receive_status === 'Received'
                      ? 'attach_money'
                      : 'money_off'
                  }}
                </v-icon>
              </v-chip>
              <span>
                {{
                  props.item.sale_receive_status === 'Received'
                    ? $t('Received')
                    : props.item.receive_status === 'Received Partially'
                    ? $t('Received Partially')
                    : props.item.receive_status === 'Received'
                    ? $t('Received')
                    : $t('Not Received')
                }}
              </span>
            </v-tooltip>
          </td>
          <td v-if="hasActionsMenuPermissions()">
            <v-menu offset-y bottom :left="!$vuetify.rtl" :right="$vuetify.rtl" transition="slide-y-reverse-transition">
              <v-btn flat fab icon class="transparent py-2" slot="activator">
                <v-icon large class="grey--text actions-btn">more_vert</v-icon>
              </v-btn>
              <v-list>
                <v-tooltip v-if="hasPermissions(['sales_show'])" :left="!$vuetify.rtl" :right="$vuetify.rtl">
                  <v-list-tile slot="activator" @click="viewRecord(props.item.sale_id)">
                    <v-icon>chrome_reader_mode</v-icon>
                    <v-list-tile-content class="px-3">{{ $t('datatable-view') }}</v-list-tile-content>
                  </v-list-tile>
                  <span>{{ $t(`View Sale's information`) }}</span>
                </v-tooltip>

                <v-tooltip
                  v-if="
                    hasPermissions(['sales_update']) &&
                      (props.item.bill_status === 'Open' || props.item.receive_type === 'Cash')
                  "
                  :left="!$vuetify.rtl"
                  :right="$vuetify.rtl"
                >
                  <v-list-tile slot="activator" @click="editRecord(props.item.sale_id)">
                    <v-icon>edit</v-icon>
                    <v-list-tile-content class="px-3">{{ $t('datatable-edit') }}</v-list-tile-content>
                  </v-list-tile>
                  <span>{{ $t(`Edit Sale's information`) }}</span>
                </v-tooltip>

                <v-tooltip
                  v-if="
                    hasPermissions(['sales_close']) &&
                      props.item.receive_type !== 'Cash' &&
                      props.item.bill_status === 'Open'
                  "
                  :left="!$vuetify.rtl"
                  :right="$vuetify.rtl"
                >
                  <v-list-tile slot="activator" @click="closeSaleRecord(props.item.sale_id)">
                    <v-icon>fa-lock</v-icon>
                    <v-list-tile-content class="px-3">{{ $t('datatable-close') }}</v-list-tile-content>
                  </v-list-tile>
                  <span>{{ $t(`Close Sale`) }}</span>
                </v-tooltip>

                <v-tooltip
                  v-if="
                    hasPermissions(['sales_unclose']) &&
                      props.item.receive_type !== 'Cash' &&
                      (props.item.bill_status === 'Close' &&
                        (props.item.receive_status === 'Not Received' || props.item.receive_status == null))
                  "
                  :left="!$vuetify.rtl"
                  :right="$vuetify.rtl"
                >
                  <v-list-tile slot="activator" @click="openSaleRecord(props.item.sale_id)">
                    <v-icon>fa-lock-open</v-icon>
                    <v-list-tile-content class="px-3">{{ $t('datatable-open') }}</v-list-tile-content>
                  </v-list-tile>
                  <span>{{ $t(`Open Sale`) }}</span>
                </v-tooltip>

                <v-tooltip
                  v-if="
                    hasPermissions(['single_statement_receive_store']) &&
                      props.item.receive_type !== 'Cash' &&
                      props.item.bill_status === 'Close' &&
                      (props.item.receive_status !== 'Received' || props.item.receive_status == null)
                  "
                  :left="!$vuetify.rtl"
                  :right="$vuetify.rtl"
                >
                  <v-list-tile slot="activator" @click="singlePayment(props.item)">
                    <v-icon>payment</v-icon>
                    <v-list-tile-content class="px-3">{{ $t('Receive') }}</v-list-tile-content>
                  </v-list-tile>
                  <span>{{ $t(`Add Payment For This Invoice`) }}</span>
                </v-tooltip>

                <v-tooltip
                  v-if="
                    hasPermissions(['sale_return_store']) &&
                      (props.item.bill_status === 'Close' || props.item.receive_type === 'Cash')
                  "
                  :left="!$vuetify.rtl"
                  :right="$vuetify.rtl"
                >
                  <v-list-tile slot="activator" @click="returnSaleRecord(props.item.sale_id)">
                    <v-icon>fa-undo</v-icon>
                    <v-list-tile-content class="px-3">{{ $t('datatable-return') }}</v-list-tile-content>
                  </v-list-tile>
                  <span>{{ $t(`Return Sale`) }}</span>
                </v-tooltip>

                <v-divider
                  v-if="
                    hasPermissions(['sales_destroy']) &&
                      (props.item.bill_status === 'Open' || props.item.receive_type === 'Cash')
                  "
                />

                <v-tooltip
                  v-if="
                    hasPermissions(['sales_destroy']) &&
                      (props.item.bill_status === 'Open' || props.item.receive_type === 'Cash')
                  "
                  :left="!$vuetify.rtl"
                  :right="$vuetify.rtl"
                >
                  <v-list-tile slot="activator" @click="showConfirmDeletion(props.item.sale_id)">
                    <v-icon class="red--text">delete</v-icon>
                    <v-list-tile-content class="red--text px-3">{{ $t('datatable-delete') }}</v-list-tile-content>
                  </v-list-tile>
                  <span>{{ $t('Delete Sale Record') }}</span>
                </v-tooltip>
              </v-list>
            </v-menu>
          </td>
        </template>

        <v-alert slot="no-results" :value="true" color="error" icon="warning">{{
          $t('Sorry, No results found for your search criteria')
        }}</v-alert>
      </v-data-table>

      <dt-pagination
        :resultData="resultData"
        :pagination="pagination"
        :perPageNumber="perPageNumber"
        @page-changed="pageChanged"
        @per-page-changed="resultsPerPageChanged"
      />
    </v-card>

    <view-sale :viewDialog="dialogs.viewDialog" @hidemodal="dialogs.viewDialog = false" />

    <add-sale
      :addDialog="dialogs.addDialog"
      @reset-datatable="resetDataTable(), resetAllErrors(true)"
      @hidemodal="resetAllErrors(true), (dialogs.addDialog = false)"
      @add-customer="dialogs.addCustomer = true"
      @add-salesman="dialogs.addSalesman = true"
    />

    <edit-sale
      :editDialog="dialogs.editDialog"
      @updated="updateDatatableResult(), (dialogs.editDialog = false), (allowGettingData = false)"
      @hidemodal="resetAllErrors(true), (dialogs.editDialog = false)"
      @add-customer="dialogs.addCustomer = true"
      @add-salesman="dialogs.addSalesman = true"
    />

    <return-sale
      :returnDialog="dialogs.returnDialog"
      @hidemodal="dialogs.returnDialog = false"
      @returned="updateDatatableResult(), (dialogs.returnDialog = false), (allowGettingData = false), goToReturn()"
    />

    <confirm-deletion
      :deleteDialog="dialogs.deleteDialog"
      :btnDeleteLoading="btnDeleteLoading"
      @hidemodal="dialogs.deleteDialog = false"
      @confirm="deleteAction()"
    />

    <add-single-receive
      :receiveDialog="dialogs.receiveDialog"
      :statement="statement"
      :account="accountReceivableInfo"
      @reset-datatable="resetDataTable(), showReceives()"
      @hidemodal="resetAllErrors(true), (dialogs.receiveDialog = false)"
    />

    <print-export-component
      :printExportDialog="dialogs.printExportDialog"
      :tableHeader="tableHeader"
      :tableBody="tableBody"
      :clickedButton="clickedButton"
      @hidemodal="dialogs.printExportDialog = false"
    />

    <add-customer
      :addDialog="dialogs.addCustomer"
      @reset-datatable="setFullCustomersList()"
      @hidemodal="resetAllErrors(true), (dialogs.addCustomer = false)"
      @add-group="dialogs.addCustomerGroup = true"
      @add-salesman="dialogs.addSalesman = true"
    />

    <add-salesman
      :addDialog="dialogs.addSalesman"
      @reset-datatable="updateFullSaleManList()"
      @hidemodal="resetAllErrors(true), (dialogs.addSalesman = false)"
      @add-staff="dialogs.addStaff = true"
    />

    <add-customer-group
      :addDialog="dialogs.addCustomerGroup"
      @reset-datatable="updateFullGroupsList()"
      @hidemodal="resetAllErrors(true), (dialogs.addCustomerGroup = false)"
    />

    <add-staff
      :addDialog="dialogs.addStaff"
      @reset-datatable="setStaffsList()"
      @hidemodal="resetAllErrors(true), (dialogs.addStaff = false)"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'
import Axios from 'axios'

export default {
  components: {
    dtSearchBox: () => import('@/views/_partials/AppSearchBox.vue'),
    dtPagination: () => import('@/views/_partials/AppDatatablePagination.vue'),
    addSale: () => import('./addSale.vue'),
    editSale: () => import('./editSale.vue'),
    viewSale: () => import('./viewSale.vue'),
    returnSale: () => import('./returnSale.vue'),
    addSingleReceive: () => import('@/views/accounting/accountReceivable/statements/addSingleReceive.vue'),
    printExportComponent: () => import('@/views/_partials/printExportComponent.vue'),
    addCustomer: () => import('@/views/customers/customers/addCustomer.vue'),
    addSalesman: () => import('@/views/staff/salesmen/addSalesman.vue'),
    addCustomerGroup: () => import('@/views/customers/groups/addGroup.vue'),
    addStaff: () => import('@/views/staff/staff/addStaff.vue')
  },

  data() {
    return {
      dialogs: {
        viewDialog: false,
        addDialog: false,
        editDialog: false,
        deleteDialog: false,
        returnDialog: false,
        receiveDialog: false,
        printExportDialog: false,
        addCustomer: false,
        addSalesman: false,
        addCustomerGroup: false,
        addStaff: false
      },
      tableBody: [],
      tableHeader: [],
      loadThePrintBtn: false,
      loadTheExportBtn: false,
      clickedButton: '',
      deleteId: 0,
      btnDeleteLoading: false,
      isDatatable: true,
      search: null,
      oldSearch: null,
      loading: false,
      defaultSortBy: 'sale_id',
      perPageNumber: 10,
      pagination: {
        sortBy: this.defaultSortBy,
        descending: true,
        page: 1,
        rowsPerPage: 10,
        totalItems: 1
      },
      oldPagination: {},
      headers: [
        // {
        //   text: this.$t('ID'),
        //   value: 'sale_id',
        //   align: 'left',
        //   sortable: true
        // },
        { text: this.$t('Bill Number'), value: 'bill_auto_number' },
        {
          text: this.$t('Salesman'),
          value: 'sale_man_name'
        },
        { text: this.$t('Customer'), value: 'customer_name' },
        {
          text: `${this.$t('Net Amount')} (${localStorage.systemCurrency})`,
          value: 'net_amount'
        },
        { text: this.$t('Bill Date'), value: 'bill_date' },
        { text: this.$t('Receive Type'), value: 'receive_type' },
        { text: this.$t('Bill Status'), value: 'bill_status' },
        { text: this.$t('Receive Status'), value: 'receive_status' }
      ],
      allowGettingData: true,
      accountReceivableInfo: {},
      statement: {}
    }
  },

  mounted() {
    this.setAppBarTitle({
      title: this.$t('Sales'),
      icon: 'attach_money'
    })

    if (this.hasActionsMenuPermissions()) {
      this.headers.push({
        text: this.$t('datatable-actions'),
        value: '',
        sortable: false
      })
    }

    this.setFullCustomersList()
    this.updateFullGroupsList()
    this.updateFullSaleManList()
    this.setStaffsList()
    this.setFullSaleProductsList()
    this.setFullAssetsList()
  },

  computed: {
    ...mapGetters({
      resultData: 'sales/getSalesList'
    })
  },

  watch: {
    pagination: {
      immediate: true,
      deep: true,
      handler() {
        let p = this.pagination
        let op = this.oldPagination
        if (p.sortBy !== op.sortBy || p.descending !== op.descending) {
          op.sortBy = p.sortBy
          op.descending = p.descending
          p.page = 1
          this.updateDatatableResult()
          this.allowGettingData = !this.allowGettingData
        } else if (this.allowGettingData || this.search !== this.oldSearch) {
          this.oldSearch = this.search
          this.updateDatatableResult()
          this.allowGettingData = !this.allowGettingData
        }
      }
    }
  },

  methods: {
    ...mapActions({
      resetAllErrors: 'errors/resetAllErrors',
      setErrorsList: 'errors/setErrorsList',
      updateResult: 'sales/updateSalesList',
      deleteRecord: 'sales/deleteSale',
      fetchSaleInfo: 'sales/fetchSaleInfo',
      fetchStatementInfo: 'receivableStatements/fetchStatementInfo',
      closeSale: 'sales/closeSale',
      openSale: 'sales/uncloseSale',
      updateFullSaleManList: 'salesmen/updateFullSalesmanList',
      updateFullGroupsList: 'customersGroups/updateFullGroupsList',
      setFullCustomersList: 'customers/setSaleCustomersList',
      setFullSaleProductsList: 'products/setFullSaleProductsList',
      setFullAssetsList: 'fixedAssets/updateFullTransferFixedAssetsList',
      setStaffsList: 'staff/setFullStaffsList'
    }),

    hasPermissions(permissions) {
      return helpers.userHasPermissions(permissions)
    },

    getNoPaginatedData(clickedButton) {
      this.clickedButton = clickedButton
      if (clickedButton === 'print') {
        this.loadThePrintBtn = true
      } else if (clickedButton === 'export') {
        this.loadTheExportBtn = true
      }
      this.tableBody = []
      this.tableHeader = []
      this.tableHeader = this.headers
      this.tableHeader = this.tableHeader.filter(f => f.text !== 'Actions' && f.text !== 'الاجراءات')

      Axios.get('sales_index', {
        params: { is_paginated: 0, search: this.search }
      })
        .then(response => {
          this.tableBody = response.data.data
          this.loadThePrintBtn = false
          this.loadTheExportBtn = false
          this.dialogs.printExportDialog = true
        })
        .catch(() => {
          this.loadThePrintBtn = false
          this.loadTheExportBtn = false
          this.dialogs.printExportDialog = false
        })
    },

    hasActionsMenuPermissions() {
      return helpers.userHasPermissions([
        'sales_show',
        'sales_store',
        'sales_update',
        'sales_destroy',
        'sales_unclose',
        'sales_close',
        'sale_return_store',
        'single_statement_receive_store'
      ])
    },

    updateDatatableResult() {
      this.loading = true
      let payload = { ...this.pagination, search: this.search }
      this.updateResult(payload)
        .then(() => {
          this.pagination.page = this.resultData.current_page
          this.loading = false
        })
        .catch(() => {
          this.loading = false
        })
    },

    resetDataTable() {
      this.allowGettingData = true
      this.pagination = {
        sortBy: null,
        descending: true,
        page: 1,
        rowsPerPage: this.perPageNumber,
        totalItems: 1
      }
      this.search = this.oldSearch = null
    },

    resultsPerPageChanged(val) {
      this.perPageNumber = val
      this.pagination.rowsPerPage = val
      this.pagination.page = 1
      this.updateDatatableResult()
    },

    pageChanged(val) {
      this.pagination.page = val
      this.updateDatatableResult()
    },

    searchValue(val) {
      this.search = val
    },

    viewRecord(id) {
      this.fetchSaleInfo(id).then(() => {
        this.dialogs.viewDialog = true
      })
    },

    editRecord(id) {
      this.fetchSaleInfo(id).then(() => {
        this.dialogs.editDialog = true
      })
    },

    showConfirmDeletion(id) {
      this.deleteId = id
      this.dialogs.deleteDialog = true
    },

    deleteAction() {
      this.btnDeleteLoading = true
      this.deleteRecord(this.deleteId)
        .then(() => {
          this.deleteId = 0
          this.btnDeleteLoading = false
          this.dialogs.deleteDialog = false
          let payload = { ...this.pagination, search: this.search }
          this.updateResult(payload)
        })
        .catch(() => {
          this.deleteId = 0
          this.btnDeleteLoading = false
          this.dialogs.deleteDialog = false
        })
    },

    closeSaleRecord(id) {
      this.closeSale(id).then(() => {
        let payload = { ...this.pagination, search: this.search }
        this.updateResult(payload)
      })
    },

    openSaleRecord(id) {
      this.openSale(id).then(() => {
        let payload = { ...this.pagination, search: this.search }
        this.updateResult(payload)
      })
    },

    returnSaleRecord(id) {
      this.fetchSaleInfo(id).then(() => {
        this.dialogs.returnDialog = true
      })
    },

    singlePayment(item) {
      this.fetchStatementInfo(item.receivable_statement_id).then(() => {
        this.statement = {
          receivable_statement_id: item.receivable_statement_id,
          amount: item.total_amount
        }
        this.accountReceivableInfo = {
          account_receivable_id: item.account_receivable_id,
          total_debit: item.total_debit,
          total_balance: item.total_balance,
          total_credit: item.total_credit,
          customer_name: item.customer_name
        }

        this.dialogs.receiveDialog = true
      })
    },

    goToReturn() {
      this.$router.push({ name: 'accounting-sales-returns' })
    },

    showReceives() {
      this.$router.push({
        name: 'accounting-account-receivable-receives',
        query: {
          account_receivable_id: this.accountReceivableInfo.account_receivable_id,
          name: this.accountReceivableInfo.customer_name
        }
      })
    }
  }
}
</script>

<style scoped />
